import { moveToFulfilled, moveToRejected, remove, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ExtractTopicSuggestionsAction } from '../../domains/publisherSuggestedTopics/types';
import { PublishersRemoveAction } from '../../domains/publishers/closeActions.types';
import { CreateCuratedTopicFulfilledAction } from '../../domains/topics/createCurateActions.types';

import { ExtractedSuggestedTopic, PublisherSuggestedTopicsLifecycle, SuggestionTopicTypes } from './types';

const initialState: PublisherSuggestedTopicsLifecycle = {
  fulfilled: { byId: {} },
  rejected: { byId: {} },
  pending: { byId: {} },
};

const suggestedTopicCreated = (
  state: PublisherSuggestedTopicsLifecycle,
  action: CreateCuratedTopicFulfilledAction
): PublisherSuggestedTopicsLifecycle => {
  const { publisherId = '', recommendationId, id } = action.payload;
  const publisherSuggestedTopics = state.fulfilled.byId[publisherId];

  if (!publisherId || !publisherSuggestedTopics) {
    return state;
  }

  const topicsWithChanges = state.fulfilled.byId[publisherId].topics.map((topic: ExtractedSuggestedTopic) => {
    if (topic.recommendationId === recommendationId) {
      return {
        ...topic,
        __typename: 'ExtractedExistingTopicSuggestion' as SuggestionTopicTypes,
        id,
      };
    }

    return topic;
  });

  return update(state, publisherId, {
    topics: topicsWithChanges,
  });
};

export type PublisherSuggestedTopicsAction =
  | ExtractTopicSuggestionsAction
  | CreateCuratedTopicFulfilledAction
  | PublishersRemoveAction;

const reducer: Reducer<PublisherSuggestedTopicsLifecycle, PublisherSuggestedTopicsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'PUBLISHER.EXTRACT_SUGGESTED_TOPICS_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.id]: {
          id: action.payload.id,
          topics: action.payload.suggestedTopics,
        },
      });
    case 'PUBLISHER.EXTRACT_SUGGESTED_TOPICS_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'TOPIC.CREATE_AND_CURATE_FULFILLED':
      return suggestedTopicCreated(state, action);
    case 'PUBLISHER.REMOVE':
      return remove(state, [action.payload.id]);
    default:
      return state;
  }
};

export default reducer;
